module.exports = __webpack_public_path__ + "img/case-logo-05.a608b0f9.png";